import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import classes from "./ContactUs.module.css";
import BreadCrumb from "../components/Breadcrumb";
import RenderToast from "../components/RenderToast";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";

export default function ContactUs() {
  const location = useLocation();

  const [formData, setFormData] = useState({
    sku: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [skuDisabled, setSkuDisabled] = useState(false);

  useEffect(() => {
    if (location.state?.sku) {
      setFormData((prev) => ({ ...prev, sku: location.state.sku }));
      setSkuDisabled(true);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { sku, name, email, phone, message } = formData;

    if (!sku) return RenderToast({ type: "error", message: "SKU is required" });
    if (!name)
      return RenderToast({ type: "error", message: "Name is required" });
    if (!email)
      return RenderToast({ type: "error", message: "Email is required" });
    if (!phone)
      return RenderToast({ type: "error", message: "Phone is required" });
    if (!message)
      return RenderToast({ type: "error", message: "Message is required" });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email))
      return RenderToast({ type: "error", message: "Invalid email format" });

    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => data.append(key, formData[key]));

      const res = await fetch(process.env.REACT_APP_CONTACT_API_BASE_URL, {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (result.success) {
        RenderToast({ type: "success", message: "Message sent successfully!" });
        setFormData({
          sku: skuDisabled ? formData.sku : "",
          name: "",
          email: "",
          phone: "",
          address: "",
          message: "",
        });
      } else {
        RenderToast({ type: "error", message: result.error });
      }
    } catch {
      RenderToast({ type: "error", message: "Server error. Try again later." });
    }

    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>
          Contact Server Stock | IT Hardware & Networking Solutions UK
        </title>
        <meta
          name="description"
          content="Get in touch with Server Stock for servers, PCs, networking products, and IT solutions across the UK and Europe. Our team is ready to assist with inquiries, orders, and support."
        />
        <link rel="canonical" href="https://www.serverstock.co.uk/contact" />
      </Helmet>

      <BreadCrumb currentPage="Get a Quote" />

      <div className={classes.contactPage}>
        {/* Modern Info Boxes */}
        {/* <div className={classes.infoBoxes}>
          <div className={classes.box}>
            <FaMapMarkerAlt className={classes.icon} />
            <p>Unit #5, The Hub, A53-61 College Road, Harrow, HA1 1AR</p>
          </div>

          <div className={classes.box}>
            <FaPhoneAlt className={classes.icon} />
            <p>
              <a href="tel:+442475420877">+44 247 542 0877</a>
            </p>
          </div>

          <div className={classes.box}>
            <FaEnvelope className={classes.icon} />
            <p>
              <a href="mailto:sales@serverstock.co.uk">sales@serverstock.co.uk</a>
              <a href="mailto:support@serverstock.co.uk">support@serverstock.co.uk</a>
            </p>
          </div>

          <div className={classes.box}>
            <FaClock className={classes.icon} />
            <p>Mon - Fri / 8:00 AM - 5:00 PM (GMT)</p>
          </div>
        </div> */}

        {/* Contact Form */}
        <div className={classes.formWrapper}>
          <form className={classes.contactForm} onSubmit={handleSubmit}>
            <h2 className={classes.title}>Get in Touch</h2>
            <p className={classes.subtitle}>We will get back to you shortly.</p>

            <div className={classes.row}>
              <div className={classes.col}>
                <input
                  type="text"
                  placeholder="SKU *"
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                  disabled={skuDisabled}
                />
              </div>

              <div className={classes.col}>
                <input
                  type="text"
                  placeholder="Full Name *"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.col}>
                <input
                  type="email"
                  placeholder="Email *"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className={classes.col}>
                <input
                  type="tel"
                  placeholder="Phone *"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={classes.fullRow}>
              <input
                type="text"
                placeholder="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>

            <div className={classes.fullRow}>
              <textarea
                placeholder="Message *"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button
              type="submit"
              className={classes.submitBtn}
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
